import z from 'zod';
import { capabilityValue } from '../../shared/capabilities';
import { firmPaymentMethodTypeValue, } from '../value-objects/firm-payment-method-type';
import { firmIdValue, firmSubscriptionIdValue, } from '../value-objects/ids';
import { stripeCustomerIdValue, stripePriceIdValue, stripePriceLookupKeyValue, stripeSubscriptionIdValue, } from '../value-objects/stripe-ids';
import { domainValue } from '../value-objects/subscription-enums';
import { firmBillingProfileSnapshotSchema } from './firm-billing-profile-snapshot';
import { firmSubscriptionEntrySchema } from './firm-subscription-entry';
export const firmSubscriptionSchema = z.object({
    billingProfile: firmBillingProfileSnapshotSchema.optional(),
    botRequestLimit: z.number().min(0),
    capabilities: z.array(capabilityValue),
    domain: domainValue,
    entry: firmSubscriptionEntrySchema,
    firmId: firmIdValue,
    id: firmSubscriptionIdValue,
    lawerConsultationFees: z.number().min(0),
    paymentFailedAt: z.date().optional(),
    stripeBankTransferIban: z.string().optional(),
    stripeCustomerId: stripeCustomerIdValue.optional(),
    stripeDefaultPaymentMethod: z.string().optional(),
    stripePaymentMethodLast4: z.string().length(4).optional(),
    stripePaymentMethodType: firmPaymentMethodTypeValue.optional(),
    stripePriceId: stripePriceIdValue.optional(),
    stripePriceLookupKey: stripePriceLookupKeyValue.optional(),
    stripeSubscriptionId: stripeSubscriptionIdValue.optional(),
});
export const firmSubscriptionsSchema = z.array(firmSubscriptionSchema);
//# sourceMappingURL=firm-subscription.js.map